export default __webpack_public_path__ + "static/media/img_ground-nft-m.c1722ce8.png";